// Project: GSSC Pilot Front-end
// Filename: asset_component.js
// Copyright European Space Agency, 2020
// This file is part of the source code package for contract PO PO 5001024866
// No part of the package, including this file, may be copied, modified,
// propagated, or distributed without prior approval by ESA.
import * as api from '@/lib/api';
import helpers from '@/lib/helpers';

export default function createComponent() {
  return {
    name: 'Asset',
    props: {
      data: Object,
      value: Boolean
    },
    data() {
      return {
        ongoingDownload: false
      };
    },
    computed: {
      iconBackground() {
        const pictureUrl = this.data.resource_type ? this.data.resource_type.picture : '';
        let iconBackground = {};
        if (pictureUrl != '' && pictureUrl != undefined) {
          iconBackground = {
            background: `linear-gradient(rgba(255, 255, 255, 0.9), rgba(255, 255, 255, 0.95)), url(${pictureUrl}) right center / contain no-repeat`
          };
        } else {
          iconBackground = {
            background: `linear-gradient(rgba(255, 255, 255, 0.9), rgba(255, 255, 255, 0.95)), url(/img/iconDefault.png) right center / contain no-repeat`
          };
        }
        return iconBackground;
      },
      auth() {
        return this.$store.getters.isAuthenticated;
      },
      isUser() {
        return this.$store.getters.isUser;
      },
      name() {
        return this.data.collection ? this.data.collection.name : '';
      },
      desc() {
        return this.data.file_format ? this.data.file_format.description : '';
      },
      doi() {
        return this.data.collection ? this.data.collection.doi : '';
      },
      filename() {
        return this.data.filename ? this.data.filename : '';
      },
      path() {
        return this.data.path ? this.data.path : '';
      },
      resource_type() {
        return this.data.resource_type ? this.data.resource_type.name : '';
      },
      file_format() {
        return this.data.file_format ? this.data.file_format.name : '';
      },
      // class_aux() {
      //   return this.data.collection.class;
      // },
      organisations() {
        return this.data.collection.network_organisation
          ? this.data.collection.network_organisation.map(o => o.name)
          : [];
      },
      // domains() {
      //   return this.data.collection.domains.map(d => d.name);
      // },
      mission() {
        return this.data.collection.mission ? this.data.collection.mission : '';
      },
      dataset() {
        return this.data.collection.dataset ? this.data.collection.dataset : '';
      },
      access_policy() {
        return this.data.collection.access_policy ? this.data.collection.access_policy : '';
      },
      tags() {
        return this.data.file_format.tags ? this.data.file_format.tags.map(el => el.name) : '';
      },
      fileType() {
        return this.data.asset_type.file_type ? this.data.asset_type.file_type : '';
      },
      constellations() {
        return this.data.constellations ? this.data.constellations : '';
      },
      satellites() {
        return this.data.satellites ? this.data.satellites : '';
      },
      observables() {
        return this.data.observables ? this.data.observables : '';
      },
      license() {
        return helpers.license(this.data.collection.license);
      },
      datalab_license() {
        return helpers.license(this.data.file_format.datalab_license);
      },
      generation_time() {
        if (this.data.generation_time) {
          const dateArray = this.data.generation_time.split(' ');
          const dateString =
            dateArray[0].toString() +
            '-' +
            dateArray[1].toString() +
            '-' +
            dateArray[2].toString() +
            'T' +
            dateArray[3].toString() +
            ':' +
            dateArray[4].toString() +
            ':' +
            dateArray[5].split('.')[0].toString() +
            'Z';
          return dateString;
        } else {
          return '';
        }
      },
      ingestion_time() {
        if (this.data.ingestion_time) {
          const dateArray = this.data.ingestion_time.split(' ');
          const dateString =
            dateArray[0].toString() +
            '-' +
            dateArray[1].toString() +
            '-' +
            dateArray[2].toString() +
            'T' +
            dateArray[3].toString() +
            ':' +
            dateArray[4].toString() +
            ':' +
            dateArray[5].split('.')[0].toString() +
            'Z';
          return dateString;
        } else {
          return '';
        }
      },
      generation_date() {
        if (this.data.generation_time) {
          const dateArray = this.data.generation_time.split(' ');
          const dateString =
            dateArray[0].toString() + '-' + dateArray[1].toString() + '-' + dateArray[2].toString();
          // const date = new Date(dateString);
          return dateString; //date.toISOString().slice(0, 10);
          //return helpers.dateFromDay(this.data.date.year, this.data.date.day_of_year);
        }
      },
      ingestion_date() {
        if (this.data.ingestion_time) {
          const dateArray = this.data.ingestion_time.split(' ');
          const dateString =
            dateArray[0].toString() + '-' + dateArray[1].toString() + '-' + dateArray[2].toString();
          // const date = new Date(dateString);
          return dateString; //date.toISOString().slice(0, 10);
          //return helpers.dateFromDay(this.data.date.year, this.data.date.day_of_year);
        }
      },
      clsHeader() {
        return {
          'bg-info': this.value,
          'selected-border-bottom': this.value
        };
      },
      clsTitle() {
        return {
          'text-white': this.value
        };
      },
      selectId() {
        return `asset__select-${this.data.id}`;
      },
      iconType() {
        switch (this.data.type) {
          case 'data':
            return 'assignment';
          case 'product':
            return 'assessment';
          case 'processing':
            return 'perm_data_setting';
          default:
            return '';
        }
      },
      noLab() {
        return this.data.resource_type
          ? this.data.resource_type.resource_type_labs === [] ||
              this.data.resource_type.resource_type_labs === 'Not Applicable'
          : true;
      },
      isProcessing() {
        // return this.data.collection.collection_type === 'Processing';
        return this.data.resource_type ? this.data.resource_type.name === 'Datalab' : false;
      },
      lab() {
        // return this.noLab ? '' : this.data.resource_type.resource_type_labs[0].name;
        return this.noLab ? '' : this.data.file_format.regular_expression;
      },
      clsIconType() {
        return {
          'text-primary': !this.value,
          'text-white': this.value
        };
      },
      clsOngoingDownload() {
        return this.ongoingDownload ? 'animated' : '';
      },
      adaptedFields() {
        // adapted fields
        return {
          filename: this.filename,
          path: this.path,
          'file_format.description': this.desc,
          'collection.network_organisation.name': this.organisations.join(', '),
          'cons_dict.cons_name': this.constellations,
          'sat_dict.sat_name': this.satellites,
          'obs_dict.obs_name': this.observables,
          'resource_type.name': this.resource_type,
          'collection.name': this.name,
          'collection.doi': this.doi,
          generation_time: this.generation_time,
          ingestion_time: this.ingestion_time
        };
      }
    },
    methods: {
      emitSelection(event) {
        this.$emit('input', event.target.checked);
      },
      // get URL for download and open in new window
      async download() {
        // const url = await api.getDownloadUrlSingle(this.data.id);
        // window.open(url);
        // return url;
        this.ongoingDownload = true;
        const response = await api.downloadAssetSingle(this.data.id);
        const blob = new Blob([response.data], { type: 'application/octet-stream' });
        const a = document.createElement('a');
        a.style.display = 'none';
        const url = window.URL.createObjectURL(blob);
        a.href = url;
        // the filename you want
        a.download = response.filename;
        document.body.appendChild(a);
        a.click();
        window.URL.revokeObjectURL(url);
        document.body.removeChild(a);
        this.ongoingDownload = false;
      },
      async downloadCsv() {
        const response = await api.downloadCsv(this.apiType);
        if (helpers.checkErrMessage(response)) {
          // a message error is received
          this.modalTitle = 'An Error Occurred';
          this.modalMessage = response.error; //.message;
          this.modalCancel = false;
          $('.message-modal').modal();
        } else {
          // Make browser download the response
          const blob = new Blob([response.data], { type: 'text/csv' });
          const a = document.createElement('a');
          a.style.display = 'none';
          const url = window.URL.createObjectURL(blob);
          a.href = url;
          // the filename you want
          a.download = 'data.csv';
          document.body.appendChild(a);
          a.click();
          window.URL.revokeObjectURL(url);
          document.body.removeChild(a);
        }
      },
      // Check if field is not empty and applicable
      applicable(field) {
        console.log('the applicable field', field);
        return field !== null && field !== undefined && field !== 'Not Applicable' && field !== ''
          ? true
          : false;
      },
      // Emit show asset modal
      emitOpenModal() {
        this.$emit('openModal', this.data);
      },
      // Emit asset lab modal
      emitAssetLabModal() {
        this.$emit(
          'openAssetLab',
          this.data,
          this.isProcessing ? this.data.resource_type.resource_type_labs[0].name : '',
          this.isProcessing
        );
      },
      // DEPRECATED (DELETE?)
      // map asset lab label to format required by API
      createLab(label) {
        const mapping = {
          'Jupyter asset': 'jupy:latest',
          // TODO: confirm other mappings
          'Zepe asset': 'zepe:latest',
          'Octave asset': 'octave:latest'
        };
        return mapping[label] || '';
      },
      getData(field) {
        return field in this.adaptedFields ? this.adaptedFields[field] : eval('this.data.' + field);
      }
    },
    mounted() {
      const pepe = 'resource_type';
      const paco = 'name';
      console.log(this.data);
      //console.log('TEST', this.data[pepe][paco]);
      // console.log(this.adaptedFields['Filename']);
    }
  };
}
